import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Discovery from './components/Discovery';
import DiscoveryFavorites from './favorites/DiscoveryFavorites';

export function CampaignDiscoveryRoutes() {
    return (
        <Routes>
            <Route path=":id" element={<Discovery />} />
            <Route path=":id/favorites" element={<DiscoveryFavorites />} />
        </Routes>
    );
}
